import React, { useState, useEffect, useRef  }  from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../styles/AboutUs.css";
import Footer from '../component/footer';
import {awardArray} from "../constant/AboutUs.js";
import {milestones} from "../constant/AboutUs.js";

const cdnURL = process.env.REACT_APP_CDN_URL;

function Counter({ targetNumber, duration = 2000, decimals = 0, prefix = "> ", suffix = "" }) {
  const [count, setCount] = useState(0);
  const [startCount, setStartCount] = useState(false);
  
  const ref = useRef(null);

  useEffect(() => {
    // Intersection Observer to watch when element is visible
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
          observer.disconnect(); // only trigger once
        }
      },
      { threshold: 0.5 } // trigger when 50% visible
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!startCount) return;

    let start = 0;
    const end = parseFloat(targetNumber);
    if (start === end) return;

    const increment = (end - start) / (duration / 16); // ~60fps
    let current = start;

    const timer = setInterval(() => {
      current += increment;

      if (current >= end) {
        clearInterval(timer);
        current = end;
      }

      setCount(current);
    }, 16);

    return () => clearInterval(timer);
  }, [startCount, targetNumber, duration]);

  // Format number with/without commas
  let formatted;
  if (decimals > 0) {
    formatted = count.toFixed(decimals);
  } else {
    const intVal = Math.floor(count);
    formatted = intVal >= 1000 ? intVal.toLocaleString() : intVal.toString();
  }

  return (
    <span ref={ref}>
      {prefix}{formatted}{suffix}
    </span>
  );
}

const AboutUs = () => {

  const [activeIndex, setActiveIndex] = useState(0);
  const refs = useRef([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const handleResize = () => {
      setScreenWidth(window.innerWidth);
  };
    
  useEffect(() => {
      window.removeEventListener('resize', handleResize);
      return () => {
          window.removeEventListener('resize', handleResize);
      }
  });

  const sliderSettings = {
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 0,    
      speed: 8000,        
      cssEase: "linear",   
      pauseOnHover: false,
      swipe: false,
      draggable: false,
  };

  const sliderSettingsMed = {
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 0,    
      speed: 8000,        
      cssEase: "linear",   
      pauseOnHover: false,
      swipe: false,
      draggable: false,
  };

  const sliderSettingsSmall = {
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 0,    
      speed: 8000,        
      cssEase: "linear",   
      pauseOnHover: false,
      swipe: false,
      draggable: false,
  };

  return (
    <div className="about-us-page">

      {/* <div style={{backgroundImage: `url("${cdnURL}/images/bg_aboutus.png")`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPositionY: "-100px",
                   position: "absolute", top: 0,left: 0, width: "100%", height: "100%", zIndex: -1,}}>
      </div> */}
      
        
        <div className="aboutus-banner">
          <img src={`${cdnURL}/images/AboutUsBanner2.jpg`} alt="aboutusBanner" />
        </div>
        

        <div className="container-vmision">
          
          <video autoPlay loop muted playsInline className="bg-video" >
            <source src={`${cdnURL}/video/globe_N1.mp4`} type="video/mp4" />
          </video>

            <div className="vmission-content">
              <div className="vmision-image">
                <img src={`${cdnURL}/images/visonmission.png`} alt="aboutusBanner" />
              </div>
              <div className="vmision-text">
                <h1> OUR <span> VISION </span></h1> 
                <p> To be at the forefront of digital innovation and connectivity,{screenWidth > 600 ? <br/> : null} creating redefining experiences that empower, inspire and{screenWidth > 600 ? <br/> : null} bring people closer together. </p>  
                
                <h1> OUR <span> MISSION </span></h1>   
                <ul className="mission-list">
                  <li>Anticipate and exceed consumers' evolving digital needs.</li>
                  <li>Create accessible, value-driven experiences that simplify, {screenWidth > 600 ? <br/> : null} enhance and elevate everyday life.</li>
                  <li>Nurture exceptional talent & cultivate innovators to become{screenWidth > 600 ? <br/> : null} the leaders of tomorrow.</li>
                  {/* <li>
                    Create talent development program to develop and retain {screenWidth > 600 ? <br/> : null} good resources in
                    the organisation
                  </li> */}
                </ul>
              </div>  
            </div>
        </div>

        <div className="container-number">
          <div className="number-subs">  
            <div>
              <img src={`${cdnURL}/icon/icon_subscribers.svg`} alt="iconSubcriber"/>
            </div>
            <div className="animateNum">
              <Counter targetNumber={2.5} duration={3000} decimals={1} /> MILLION
            </div>
            <div>
              <p>Subscribers <br/> Nationwide</p>
            </div>
          </div>
          <div className="number-dealer">
            <div>
              <img src={`${cdnURL}/icon/icon_dealership.svg`} alt="iconDealer"/>
            </div>
            <div className="animateNum">
              <Counter targetNumber={20000} duration={3000} decimals={0} /> 
            </div>
            <div>
              <p>Active Dealerships <br/> Every Month</p>
            </div>
          </div>
          <div className="number-user">
            <div>
              <img src={`${cdnURL}/icon/icon_digitalusers.svg`} alt="iconDealer"/>
            </div>
            <div className="animateNum">
              <Counter targetNumber={1.9} duration={3000} decimals={1} /> MILLION
            </div>
            <div>
              <p>Digital Users On Our <br/> Mobile App</p>
            </div>
          </div>
        </div>

        <div className="container-awards">
          <div className="award-title" >
              <h1 className="sec4 mb-4 text-center">OUR <span> AWARDS </span></h1>
          </div>
          <Slider {...(screenWidth > 1300 ? sliderSettings : screenWidth > 600 ? sliderSettingsMed : sliderSettingsSmall)}>
            {awardArray.map((card, index) => (
              <div key={index} className="px-2">
                <div className="award-slide">
                  <img src={card.image} alt={card.title} />
                </div>
              </div>
            ))}
          </Slider>
        </div>
        
        <div className="container-milestones">
          <div className="miles-title">
            <h1>
              MILESTONES
            </h1>
            <span>
              A journey of bold innovation, continuous growth, and strategic partnerships that define{screenWidth > 600 ? <br/> : null} who we are today and drive our future forward.
            </span>
          </div>
          
          <div className="miles-content">
            <div className="miles-image">
              <img src={milestones[activeIndex].image} alt={milestones[activeIndex].year} />
            </div>
            <div className="miles-timeline">
              {milestones.map((item, index) => (
                <div key={index} className={`timeline-item ${ activeIndex === index ? "active" : "" }`} onMouseEnter={() => setActiveIndex(index)} 
                  onClick={() => setActiveIndex(index)} >
                  <span className="dot" />
                  <div className="year">{item.year}</div> 
                  <span className="dash">-</span>
                  <ul className="points">
                    {item.points.map((point, i) => (
                      <li key={i} dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div style={{padding:"0px 5.208vw"}}>
          <Footer/>
        </div>
    </div>


  );
};

export default AboutUs;